import { render, staticRenderFns } from "./Goodsclass.vue?vue&type=template&id=65855d3d&scoped=true"
import script from "./Goodsclass.vue?vue&type=script&lang=js"
export * from "./Goodsclass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65855d3d",
  null
  
)

export default component.exports